import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SignIn } from '@clerk/clerk-react';
import viitumMark from '../assets/viitum-mark.png';
import './AuthShell.css';

export default function SignInPage() {
  const [params] = useSearchParams();
  const redirectUrl = params.get('redirect_url') || '/presale-v2';

  return (
    <div className="auth-shell">
      <div className="auth-shell-bg" aria-hidden />
      <Link to="/" className="auth-shell-brand">
        <img src={viitumMark} alt="VIITUM" />
        <span>VIITUM</span>
      </Link>
      <div className="auth-shell-card">
        <SignIn
          routing="path"
          path="/sign-in"
          signUpUrl="/sign-up"
          fallbackRedirectUrl={redirectUrl}
          forceRedirectUrl={redirectUrl}
        />
      </div>
      <Link to="/" className="auth-shell-back">← Back to home</Link>
    </div>
  );
}
